import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  policyCoverId: '',
  lineId: '',
  lineName: '',
  policyCoverName: '',
  policyCoverExternalCode: '',
  arabicName: '',
  policyCoverPrintingOrder: '',
  policyCoverDescription: '',
  policyCoverTreatyID: '',
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      lineName: {
        name: 'lineName',
        title: 'Line',
        type: FormFieldType.select,
        placeholder: 'Line',
        value: !isEmpty(initialValues.lineName) ? initialValues.lineName : '',
        disabled: false,
        required: true,
        selectOptions: {},
      },
      policyCoverName: {
        name: 'policyCoverName',
        title: 'Policy Cover Name',
        type: FormFieldType.text,
        placeholder: 'Policy Cover Name',
        value: !isEmpty(initialValues.policyCoverName)
          ? initialValues.policyCoverName
          : '',
        required: true,
      },
      policyCoverExternalCode: {
        name: 'policyCoverExternalCode',
        title: 'External Code',
        type: FormFieldType.text,
        placeholder: 'External Code',
        value: !isEmpty(initialValues.policyCoverExternalCode)
          ? initialValues.policyCoverExternalCode
          : '',
        required: true,
      },
      arabicName: {
        name: 'arabicName',
        title: 'Arabic Name',
        type: FormFieldType.text,
        placeholder: 'Arabic Name',
        value: !isEmpty(initialValues.arabicName)
          ? initialValues.arabicName
          : '',
        required: true,
      },
      policyCoverPrintingOrder: {
        name: 'policyCoverPrintingOrder',
        title: 'Printing Order',
        placeholder: 'Printing Order',
        type: FormFieldType.number,
        value: !isEmpty(initialValues.policyCoverPrintingOrder)
          ? initialValues.policyCoverPrintingOrder
          : [],
        required: true,
      },
      policyCoverDescription: {
        name: 'policyCoverDescription',
        title: 'Description',
        placeholder: 'Description',
        type: FormFieldType.text,
        value: !isEmpty(initialValues.policyCoverDescription)
          ? initialValues.policyCoverDescription
          : [],
        required: true,
      },
      policyCoverTreatyID: {
        name: 'policyCoverTreatyID',
        title: 'Treaty',
        type: FormFieldType.select,
        placeholder: 'Treaty',
        value: !isEmpty(initialValues.policyCoverTreatyID)
          ? initialValues.policyCoverTreatyID
          : '',
        disabled: false,
        required: false,
        selectOptions: {},
      },
    },
  },
];
